<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :label-width="formLabelWidth" ref="form">
            <el-form-item label="">
                <div class="edit_container">
                    <editor v-if="is_editor" :text="form.content" ref="ue"></editor>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { activityDetail, pubEdit } from '@/api/education';
    import Editor from '@/components/tsk/editor-quill'

    export default {
        components: {Editor},
        data() {
            return {
                title: '公示信息',
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,

                form: {
                    activity_id: '',
                    content: '',
                },
                detail: [],
                is_editor: false,
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.$message({message: '获取详情失败', type: 'error'});
                } else {
                    this.form.activity_id = row.activity_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
                this.is_editor = true
            },
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        pubEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.is_editor = false
                this.dialogFormVisible = false
            },
            getDetail() {
                activityDetail({id: this.form.activity_id}).then((result) => {
                    this.form.content = result.data.publish_content
                    this.ue_loading = true
                })

            },
            /*获取富文本内容*/
            contentChangeFunc(e) {
                this.form.content = e
            },
        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/test/publish-content.vue